import React from "react";
import { AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Container, StyledMainAccordion, StyledAccordionDetails } from "./styles";

interface CustomAccordionProps<T> {
  data: T[];
  renderSummary: (item: T) => React.ReactNode;
  children: (item: T) => React.ReactNode;
  onChange?: (itemKey: string, isExpanded: boolean) => void;
}

export const CustomAccordion = <T,>({
  data,
  renderSummary,
  children,
  onChange
}: CustomAccordionProps<T>) => {
  return (
    <Container>
      {data.map((item, index) => (
        <StyledMainAccordion
          key={index}
          onChange={(_, isExpanded) => {
            if (onChange && (item as any).groupName) {
              onChange((item as any).groupName, isExpanded);
            }
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel-content-${index}`}
            id={`panel-header-${index}`}
          >
            {renderSummary(item)}
          </AccordionSummary>
          <StyledAccordionDetails>
            {children(item)}
          </StyledAccordionDetails>
        </StyledMainAccordion>
      ))}
    </Container>
  );
};
